import React from "react";
import BottomBar from "./BottomBar";

const DEFAULT_LOGO_URL =
  "https://kwbgrjakobarqelunebd.supabase.co/storage/v1/object/public/pictures/Icon/3.png";

const PENGUIN_URL =
  "https://kwbgrjakobarqelunebd.supabase.co/storage/v1/object/public/pictures/MVP4/Public%20Pages/Landing/gwin-penguin.png";

export default function AppScreenShell({
  title = "",
  subtitle = "",
  eyebrow = "",
  icon = null,
  message = "",
  children,
  showHeader = true,
  showBottomBar = true,
  showPenguinBackground = true,
  maxWidth = "max-w-2xl",
  contentClassName = "",
}) {
  return (
    <div
      className="
        relative
        min-h-[100dvh]
        overflow-x-hidden
        bg-white
        font-sans
        text-[#333333]
      "
      style={{
        paddingTop: "env(safe-area-inset-top, 0px)",
      }}
    >
      {/* =========================================================
          FIXED BACKGROUND DECORATION
          Stays with the viewport while the user scrolls
          ========================================================= */}
      <div className="pointer-events-none fixed inset-0 z-0 overflow-hidden">
        {/* Top-right glow */}
        <div
          className="
            absolute
            -right-24
            top-20
            h-64
            w-64
            rounded-full
            bg-[#FF914D]/12
            blur-3xl
          "
        />

        {/* Left glow */}
        <div
          className="
            absolute
            -left-24
            top-[42%]
            h-72
            w-72
            rounded-full
            bg-[#FFD6BD]/35
            blur-3xl
          "
        />

        {/* Bottom-right glow */}
        <div
          className="
            absolute
            bottom-12
            right-[-80px]
            h-56
            w-56
            rounded-full
            bg-[#FFE8D8]/70
            blur-2xl
          "
        />

        {showPenguinBackground && (
          <div
            className={`
              relative
              mx-auto
              h-full
              w-full
              ${maxWidth}
            `}
          >
            {/* =====================================================
                RIGHT PENGUIN

                POSITION:
                right-[-24%] = horizontal
                top-[90px]   = vertical

                SIZE:
                w-[41%]

                ROTATION:
                rotate-[-58deg]
                ===================================================== */}
            <img
              src={PENGUIN_URL}
              alt=""
              aria-hidden="true"
              className="
                absolute

                right-[-24%]
                top-[90px]

                w-[41%]

                rotate-[-58deg]
                object-contain
                opacity-55
                select-none
              "
              loading="eager"
              decoding="async"
              draggable="false"
            />

            {/* =====================================================
                LEFT PENGUIN

                POSITION:
                left-[-28%] = horizontal
                top-[62%]   = vertical

                SIZE:
                w-[55%]

                ROTATION:
                rotate-[62deg]
                ===================================================== */}
            <img
              src={PENGUIN_URL}
              alt=""
              aria-hidden="true"
              className="
                absolute

                left-[-28%]
                top-[62%]

                w-[55%]

                -translate-y-1/2
                rotate-[62deg]
                object-contain
                opacity-55
                select-none
              "
              loading="eager"
              decoding="async"
              draggable="false"
            />
          </div>
        )}
      </div>

      {/* =========================================================
          HEADER
          ========================================================= */}
      {showHeader && (
        <header
          className="
            sticky
            top-0
            z-40
            w-full
            border-b
            border-[#EFEFEF]
            bg-white/90
            backdrop-blur
          "
        >
          <div
            className={`
              mx-auto
              flex
              w-full
              ${maxWidth}
              items-center
              justify-between
              px-5
              py-3
              min-[375px]:px-6
              sm:px-8
            `}
          >
            <img
              src={DEFAULT_LOGO_URL}
              alt="Gwin"
              className="h-11 w-auto object-contain"
              loading="eager"
              decoding="async"
              draggable="false"
            />
          </div>
        </header>
      )}

      {/* =========================================================
          MAIN CONTENT
          ========================================================= */}
      <main
        className={[
          "relative z-10 mx-auto w-full px-5 pt-6 min-[375px]:px-6 sm:px-8",
          maxWidth,
          showBottomBar ? "pb-[112px]" : "pb-10",
          contentClassName,
        ].join(" ")}
        style={
          showBottomBar
            ? {
                paddingBottom:
                  "calc(112px + env(safe-area-inset-bottom, 0px))",
              }
            : undefined
        }
      >
        {(eyebrow || title || subtitle) && (
          <header className="mb-5">
            {eyebrow && (
              <p className="text-[11px] font-black uppercase tracking-[0.18em] text-[#FF914D]">
                {eyebrow}
              </p>
            )}

            <div className="mt-2 flex items-center gap-3">
              {icon && (
                <div
                  className="
                    flex
                    h-11
                    w-11
                    shrink-0
                    items-center
                    justify-center
                    rounded-2xl
                    bg-[#FF914D]
                    text-white
                    shadow-[0_12px_24px_rgba(255,145,77,0.25)]
                  "
                >
                  {icon}
                </div>
              )}

              <div className="min-w-0">
                {title && (
                  <h1 className="text-[30px] font-black leading-tight tracking-[-0.035em] text-[#333333]">
                    {title}
                  </h1>
                )}

                {subtitle && (
                  <p className="mt-1 text-sm font-semibold leading-relaxed text-[#757575]">
                    {subtitle}
                  </p>
                )}
              </div>
            </div>
          </header>
        )}

        {message && (
          <section
            className="
              relative
              mb-5
              overflow-hidden
              rounded-[26px]
              bg-[#FF914D]
              px-5
              py-4
              text-white
              shadow-[0_18px_35px_rgba(255,145,77,0.22)]
            "
          >
            <p className="text-sm font-bold leading-relaxed">
              {message}
            </p>
          </section>
        )}

        {children}
      </main>

      {showBottomBar && <BottomBar />}
    </div>
  );
}